<mat-dialog-content class="content-dialog">
  <div class="dialog-container">
    <div class="dialog-header d-flex">
      <div class="header-text">
        {{ data.headerText ? data.headerText : title }}
      </div>
      <button
        mat-flat-button
        class="md circle"
        (click)="closeDialog()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-divider></mat-divider>
    <div
      class="dialog-content"
      [formGroup]="form"
    >
      <div
        class="row"
        *ngIf="(isDirectApplicant$ | async); else passiveActiveText"
      >
        <mat-form-field
          [ngClass]="{'col-12': !stateFormControl.value, 'col-md-12': !stateFormControl.value,
            'col-12': stateFormControl.value, 'col-md-6': stateFormControl.value, 'col-sm-12': stateFormControl.value}"
          color="accent"
          appearance="fill"
        >
          <mat-label>Phase</mat-label>
          <mat-select
            required
            formControlName="phase"
          >
            <mat-option
              *ngFor="let phase of phaseOptions"
              [value]="phase.id"
            >{{phase.label}}
            </mat-option>
            <mat-option
              *ngIf="getDisabledPhaseLabel$() | async as disabledPhaseLabel"
              [value]="phaseFormControl.value"
              [disabled]="true"
            >{{disabledPhaseLabel}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <ng-container *ngIf="stateOptions$ | async as stateOptions">

          <mat-form-field
            class="col-12 col-md-6"
            color="accent"
            appearance="fill"
          >
            <mat-label>State</mat-label>
            <mat-select
              formControlName="state"
              required
            >
              <mat-option
                *ngFor="let state of stateOptions"
                [value]="state.id"
              >{{state.label}}</mat-option>
              <mat-option
                *ngIf="getDisabledStateLabel$(stateOptions) | async as
                disabledStateLabel"
                [value]="stateFormControl.value"
                [disabled]="true"
              >{{disabledStateLabel}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>

      </div>
      <mojo-candidate-association-reasons
        formControlName="reasons"
        [reject]="data.reject"
        [reasons]="reasons$ | async"
        [multiple]="enableMultiReasonSelection$ | async"
        [isRequired]="true"
        [commentFormControl]="commentFormControl"
      >
      </mojo-candidate-association-reasons>
      <mojo-editor
        formControlName="comment"
        [placeholder]="'Comment'"
        [material]="true"
        [required]="!commentFormControl.valid"
        toolbar=""
      >
      </mojo-editor>

      <!--      <ng-select-->
      <!--        class="select-styles"-->
      <!--        *ngIf="showEmailTemplates$ | async"-->
      <!--        placeholder='Choose rejection email template'-->
      <!--        [items]="emailTemplateOptions$ | async"-->
      <!--        [clearable]="false"-->
      <!--        bindLabel="title"-->
      <!--        bindValue="id"-->
      <!--        data-cy="email-template-selection"-->
      <!--        formControlName="emailTemplateId"-->
      <!--      >-->
      <!--      </ng-select>-->

      <div class="move-to-shortlist-modal-buttons">
        <button
          color="accent"
          class="mr-2"
          mat-button
          type="button"
          (click)="closeDialog()"
        >Cancel
        </button>
        <button
          color="primary"
          class="md"
          mat-flat-button
          type="button"
          [disabled]="form.invalid || buttonDisabled"
          (click)="onSubmit()"
        >SAVE
        </button>
      </div>

    </div>
  </div>

  <ng-template #passiveActiveText>
    <div class="passive-candidate-text">The candidate will be marked as an
      direct applicant, once application is
      received
    </div>
  </ng-template>
</mat-dialog-content>
